import { TableConfigurationDTO } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function fetchTableConfiguration(component: string) {
  const response = await fetch(
    `${STRAPI_URL}/table-configuration/${component}`,
    {
      credentials: "include",
    }
  );

  // Avoid JSON parse crashes on empty auth/error responses.
  if (!response.ok) {
    return null;
  }

  const raw = await response.text();
  if (!raw || raw.trim().length === 0) {
    return null;
  }

  return JSON.parse(raw) as TableConfigurationDTO | null;
}
export async function saveTableConfiguration(
  configuration: TableConfigurationDTO
) {
  const response = await fetch(`${STRAPI_URL}/table-configuration`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(configuration),
  });

  if (response.status >= 400) {
    throw new Error(`Save failed with status ${response.status}.`);
  }
}
